import { useState } from "react";

const DEFAULT_AI_COMFORT_LEVELS = [
  "Level 1: I do not use AI tools",
  "Level 2: I use basic chatbots (Gemini, Grok, ChatGPT, Claude)",
  "Level 3: Advanced AI user (I use AI to code, build agents, tools and workflows.)",
];

export default function AIComfortLevelSelector({ form, updateField }) {
  const [message, setMessage] = useState("");

  const selected = Array.isArray(form.AI_Comfort_Level)
    ? (form.AI_Comfort_Level[0] || "")
    : "";

  const setMsg = (msg) => {
    setMessage(msg);
    if (msg) setTimeout(() => setMessage(""), 1500);
  };

  const selectLevel = (value) => {
    updateField("AI_Comfort_Level", [value]); // ✅ single item array
    setMsg("Saved successfully ✅");
  };

  return (
    <div className="rounded-xl border border-pink-400/20 bg-white/5 p-4">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="text-pink-300 text-sm font-semibold">
          How comfortable are you with using AI?
        </p>

        <span className="text-xs text-white/60 whitespace-nowrap">
          {selected ? "1 selected" : "Pick 1"}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
        {DEFAULT_AI_COMFORT_LEVELS.map((level) => (
          <label
            key={level}
            className="min-w-0 flex items-start gap-2 text-[13px] sm:text-sm text-white/85 leading-snug cursor-pointer hover:text-white"
          >
            <input
              type="radio"
              name="ai_comfort"
              className="mt-1 accent-pink-500 flex-shrink-0"
              checked={selected === level}
              onChange={() => selectLevel(level)}
            />
            <span className="min-w-0 whitespace-normal break-words">{level}</span>
          </label>
        ))}
      </div>

      {message && (
        <p className={`text-sm mt-2 ${message.includes("Saved") ? "text-green-400" : "text-red-400"}`}>
          {message}
        </p>
      )}
    </div>
  );
}